import React from 'react';
import cx from 'classnames';

import { getInitialsFromName } from '@trqk/utils';

import './avatar.css';

interface Props {
    gradientColor: ColorGrade;
    imageUrl?: string;
    name: string;
    width?: number;
    textSize?: 'small' | 'large';
}

/**
 * Displays a round icon for a user. Either an imageUrl or a name must be provided.
 * If an imageUrl is provided, the image is used as the icon.
 * If an imageUrl is not provided, the name is converted to first and last initials and these are
 * displayed over a gradient background using the gradientColor to apply styling.
 */
export const Avatar = ({
    gradientColor,
    name,
    imageUrl,
    width = 40,
    textSize = 'small',
}: Props): JSX.Element => {
    const classNames = cx(
        'avatar rounded-full flex justify-center items-center text-white align-middle',
        {
            'text-sm font-semibold': textSize === 'small',
            'text-lg font-bold': textSize === 'large',
        },
    );

    return imageUrl ? (
        <img
            src={imageUrl}
            alt={`Avatar for ${name}`}
            className={`${classNames} `}
            style={{
                width,
                height: width,
                borderRadius: '50%',
            }}
        />
    ) : (
        <div
            className={`${classNames} ${gradientColor}`}
            style={{
                width,
                height: width,
            }}
        >
            {getInitialsFromName(name)}
        </div>
    );
};
